import Vue from 'vue'
import Router from 'vue-router'
import index from './views/Newindex.vue'
import layout from './views/layout/index.vue'

Vue.use(Router)
export default new Router({
  mode: 'hash',
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   component: index,
    // },
    {
      path: '/',
      name: 'index',
      component: layout,
      redirect:'Newindex',
      children: [{
        path: 'Newindex',
        component: () => import('./views/Newindex.vue')
      },
    {
      path: 'NewFreeRegistration',
      component: () => import('./views/NewFreeRegistration.vue')
    }
    ]
    },
    {
      path: '/',
      name: 'index',
      component: layout,
      children: [{
          path: 'Lifecycle',
          component: () => import('./views/Lifecycle.vue')
        },
        {
          path: 'Setmeal',
          component: () => import('./views/Setmeal.vue')
        },
        {
          path: 'NewPackagedetails',
          name:'NewPackagedetails',
          component: () => import('./views/NewPackagedetails.vue')
        },
        {
          path: 'Product',
          component: () => import('./views/Product.vue')
        },
        {
          path: 'ProductDetails',
          name:'ProductDetails',
          component: () => import('./views/ProductDetails.vue')
        },
      ]
    },
    {
      path: '/',
      component: layout,
      children: [{
          path: 'Designer',
          component: () => import('./views/Designer.vue')
        },
        {
          path: 'Sketch',
          component: () => import('./views/Sketch.vue')
        },
        {
          path: 'Panorama',
          component: () => import('./views/Panorama.vue')
        },
        {
          path: 'Casedetails',
          component: () => import('./views/Casedetails.vue')
        },
        {
          path: '/PanoramaList',
          name: 'PanoramaList',
          component: () => import( './views/PanoramaList.vue')
        },
      ]
    },
    {
      path: '/',
      name: 'index',
      component: layout,
      children: [{
          path: 'DecorationCase',
          component: () => import('./views/DecorationCase.vue')
        },
        {
          path: '/Decorationdetails',
          name: 'Decorationdetails',
          component: () => import('./views/Decorationdetails.vue')
        },
        {
          path: 'DecorationProcess',
          component: () => import('./views/DecorationProcess.vue')
        },
        {
          path: 'Onlinesite',
          component: () => import('./views/Onlinesite.vue')
        },
        {
          path: '/OnlinesiteDetails',
          name: 'OnlinesiteDetails',
         
          component: () => import( './views/OnlinesiteDetails.vue'),
    
        },
      ]
    },
    {
      path: '/',
      name: 'index',
      component: layout,
      children: [{
          path: 'NewJoin',
          component: () => import('./views/NewJoin.vue')
        },
        {
          path: 'NewManufacturer',
          component: () => import('./views/NewManufacturer.vue')
        },

      ]
    },
    {
      path: '/',
      name: 'index',
      component: layout,
      children: [{
          path: 'Renovationloan',
          component: () => import('./views/Renovationloan.vue')
        },
        {
          path: 'DecoMethod',
          component: () => import('./views/DecoMethod.vue')
        },
        {
          path: '/HowDeco',
          name: 'HowDeco',
          component: () => import('./views/HowDeco.vue'),
        },
      ]
    },
    {
      path: '/',
      name: 'NewFreeRegistration',
      component: layout,
      children: [{
        path: 'NewFreeRegistration',
        component: () => import('./views/NewFreeRegistration.vue')
      }, ]
    },
    // {
    //   path: '/',
    //   name: 'NewAbouts',
    //   component: layout,
    //   children: [{
    //     path: 'NewAbouts',
    //     component: () => import('./views/NewAbouts.vue')
    //   }, ]
    // },
    {
      path: '/NewAbouts',
      name: 'NewAbouts',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/NewAbouts.vue')
    },
    {
      path: '/Packagedetails',
      name: 'Packagedetails',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/Packagedetails.vue'),
    },
    {
      path: '/PanoramaList',
      name: 'PanoramaList',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/PanoramaList.vue')
    },
    {
      path: '/Casedetails',
      name: 'Casedetails',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/Casedetails.vue')
    },
    {
      path: '/Manufacturer',
      name: 'Manufacturer',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/Manufacturer.vue')
    },
   
    {
      path: '/BackProduct',
      name: 'BackProduct',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/BackProduct.vue')
    },
    {
      path: '/BackProductDetails',
      name: 'BackProductDetails',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/BackProductDetails.vue')
    },
  
  
    {
      path: '/baidumap',
      name: 'baidumap',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import( /* webpackChunkName: "about" */ './views/baidumap.vue')
    },
  ]

})